import { TApiCamera, TCamera } from 'types';

export const convertCameraToAppSchema = (cameraList: TApiCamera[]): TCamera[] => {
  return cameraList.map((item) => ({
    id: String(item.id),
    name: item.name,
    rtmpUrl: item.rtmp_url,
  }));
};
